import { TranslationKeys } from '@/localization';
import { DataSource } from '@/models/dataSource';
import { FC, useEffect } from 'react';

import DownloadIcon from '@/assets/icons/download.svg?react';
import { IconButton } from '@/lib';
import { useTranslation } from 'react-i18next';
import { usePostDataSourceDownloadUrlMutation } from '@/services/dataSources';
import { useWorkspace } from '@/features/workspaces/hooks';

type DataSourceDownloadButtonProps = {
  datasource: DataSource;
  buttonText?: TranslationKeys;
};

export const DataSourceDownloadButton: FC<DataSourceDownloadButtonProps> = ({ datasource, buttonText }) => {
  const { t } = useTranslation();
  const workspace = useWorkspace();

  const [postDataSourceDownloadUrl, { data, isLoading, isSuccess }] = usePostDataSourceDownloadUrlMutation();

  useEffect(() => {
    postDataSourceDownloadUrl({
      workspaceId: workspace.id,
      dataSourceId: datasource.id,
    });
  }, []);

  const handleDownloadFileClicked = () => {
    if (data) {
      window.open(data.url, '_parent');
    }
  };

  return (
    <IconButton
      intent='link-grey'
      className='!p-1.5 text-tertiary-600'
      text={t(buttonText as any)}
      leadingIcon={<DownloadIcon className='text-quaternary-400' />}
      disabled={isLoading || !isSuccess}
      onClick={handleDownloadFileClicked}
    />
  );
};
